import React from 'react'

/**
 * Minimal "+" glyph. Neither `ext-ui/svg/icon/` nor the legacy
 * `src/components/Svgs/` set ships a plain plus icon (the same design gap
 * VendorsPage documents in its own local `PlusIcon`) — this is a local
 * stand-in for the vendor-picker "Add vendor" actions. Colored via
 * `currentColor` so callers control it through the surrounding text color.
 */
export const PlusIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox={'0 0 16 16'}
    fill={'none'}
    aria-hidden={'true'}
  >
    <path
      d={'M8 2.5V13.5M2.5 8H13.5'}
      stroke={'currentColor'}
      strokeWidth={1.5}
      strokeLinecap={'round'}
    />
  </svg>
)
